export default __webpack_public_path__ + "static/media/frame1.6cf6f243.PNG";